module.exports = __webpack_public_path__ + "media/location-service_en_ipad_new.356edf7b.mp4";